module.exports = __webpack_public_path__ + "media/src/images/icons/link-chevron-forward-b795afbf0bec51013b6acb517b672dc5.svg";